import React, { useEffect, useState } from "react";
import "./subscriptionOverview.scss";
import { Bar } from "react-chartjs-2";
import { Dropdown, Spinner } from "react-bootstrap";
import MembersPageLoader from "../../settingsV2/members/MembersPageLoader";
import useGetSBAccountTile from "../../../hooks/get-sb-account-tile.hook";
import StatsTile from "./StatsTile";
import DateRangePickerWithInputs from "../../Common/date-range-picker-with-inputs/date-range-picker-with-inputs.component";
import useDateDefineds from "../../../hooks/date-defineds.hook";
import { DATE_FORMAT } from "../../../constants/app.constants";
import moment from "moment";
import MapComponent from "../../Common/map/map.component";
import useDateFormat from "../../../hooks/use-date-format.hook";
import { 
  useLocation
} from "react-router-dom";
import { SubscriptionOverviewChartBlock } from "./subscription-overview";
import { TrialPerformance } from "./info-tables";
import MyLineChart from "../../chartjs/my-line.chart";
// date-fns replacement imports (using custom utility instead of date-fns)
import { 
} from "../../../utils/date-fns-replacement";


const SubscriptionOverview = () => { 
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const variant = queryParams.get("variant");
  const mode = queryParams.get("mode");
  const isDistributor = mode === "distributor";

  const dateFormat = useDateFormat();
  const defineds = useDateDefineds();
  const [selectedDateFilter, setSelectedDateFilter] = useState({
    startDate: defineds.startOfLastTwelveMonth,
    endDate: defineds.endOfToday,
    label: 'Last 12 Months'
  });
  const { data: pageData, isLoading: pageLoading, fetchData } = useGetSBAccountTile();
  const showPageLoader = pageLoading && !pageData;

  useEffect(() => {
    fetchData({
      fromDate: moment(defineds.startOfLastTwelveMonth).format(DATE_FORMAT),
      endDate: moment(defineds.endOfToday).format(DATE_FORMAT),
    });
  }, []);

  const statsConfig = [
    { title: "Active", value: pageData?.stats?.active ?? 0 },
    { title: "Suspended", value: pageData?.stats?.suspended ?? 0 },
    { title: "Active trials", value: pageData?.stats?.active_trials ?? 0 },
    { title: "Expired Trial", value: pageData?.stats?.expired_trial ?? 0 },
    { title: "Paid accounts", value: pageData?.stats?.paid ?? 0 },
    { title: "Overall Accounts", value: pageData?.stats?.overall ?? 0 },
  ];

  const signUpsData = {
    labels: pageData?.signups?.points?.map((item) => item.Label),
    datasets: [
      {
        data: pageData?.signups?.points?.map((item) => item.Value),
        label: "",
        borderColor: "#008fd4",
        backgroundColor: "#008fd4",
        fill: true,
        pointRadius: 0,
        borderWidth: 2,
      },
    ],
  };

  const newAccountsData = {
    labels: pageData?.newAccounts?.points?.map((item) => item.Label),
    datasets: [
      { 
        data: pageData?.newAccounts?.points?.map((item) => item.Value) ?? [],
        label: "",
        borderColor: "#008fd4",
        backgroundColor: "#008fd409",
        fill: true,
        pointRadius: 0,
        borderWidth: 2,
      },
    ],
  };

  function average(ctx) {
    const values = ctx.chart.data.datasets[0].data;
    return values.reduce((a, b) => a + b, 0) / values.length;
  }
  const newAccountsOptions = {
    tension: 0.4,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x:
        {
          grid: {
            display: false,
          },
          ticks: {
            display: false,
          },
          border: {
            display: false,
          },
        },
      y: 
        {
          min: 0,
          grid: {
            display: false,
          },
          position: "right",
          ticks: {
            display: false,
          },
          border: {
            display: false,
          },
        },
    },
 
    responsive: true,
    maintainAspectRatio: true,
  };
  const signUpsOptions = {
    tension: 0.4,
    legend: {
      display: false,
    },
    annotation: {
      annotations: [
        {
          type: "line",
          borderColor: "red",
          borderDash: [1, 1],
          borderDashOffset: 0,
          borderWidth: 1,
          label: {
            enabled: true,
            content: (ctx) => "Average: " + average(ctx).toFixed(2),
            // position: "end",
          },
          scaleID: "x",
          value: (ctx) => {
            console.log(ctx);
            return average(ctx);
          },
        },
      ],
    },
    datalabels: {
      display: false,
    },
    style: {
      strokewidth: 1,
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
      },
      y: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
    title: {
      display: false,
    },

    plugins: {
      legend: {
        display: false,
      },

      autocolors: true,
      annotation: {
        annotations: {
        },
      },
      datalabels: {
        backgroundColor: "transparent",
        color: "transparent",
      },
    },
  };

  const handleDateChange = (ranges, label) => {
    setSelectedDateFilter({...ranges, label});
    fetchData({
      fromDate: moment(ranges.startDate).format(DATE_FORMAT),
      endDate: moment(ranges.endDate).format(DATE_FORMAT),
    });
  }

  return (<>
{showPageLoader ? <MembersPageLoader/> : 
<div className="px-4 subscription-overview">
      <div className="p-4" />
      
      {variant === "v2" ? (
        <div style={{ marginBottom: '24px' }}>
        <SubscriptionOverviewChartBlock 
          activeMSPAccounts={pageData?.activeMSPAccounts}
          statsConfig={statsConfig}
          isDistributor={isDistributor}
        />
        {
          isDistributor && (
              <TrialPerformance isDistributor={isDistributor}/>
          )
        }
          </div>
      ) : (
  <>
      <div className="d-flex align-items-lg-center flex-column flex-lg-row mb-3 gap-8">
        <div className="d-flex align-items-center">
          <div className="f-500 f-grey mr-2 d-none d-sm-block">For period</div>
          <div className="d-flex align-items-center bg-grey radius-4">
          <Dropdown
                  className="date-filter-dropdown m-1 dashboardDateFilter"
                  alignRight
                  onToggle={(e) => {
                    
                  }}
                >
                  <Dropdown.Toggle className="p-0">
                    <div className="d-flex align-items-center p-2 bg-grey f-grey f-500 radius-4">
                      {selectedDateFilter?.label}
                      <img
                        src="/images/big-chevron-down.svg"
                        alt=""
                        className={`ml-2 ${
                          false ? "rotate180" : ""
                        }`}
                      />
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    className="p-0"
                      style={{
                        zIndex: 4,
                        minWidth: 'auto',
                        width: 'auto',
                        maxWidth: '320px',
                      }}
                  >
                    <DateRangePickerWithInputs
                      startDate={selectedDateFilter?.startDate}
                      endDate={selectedDateFilter?.endDate}
                      onDateChange={handleDateChange}
                      dateFormat={dateFormat}
                    />
                  </Dropdown.Menu>
                </Dropdown>

                <div className="px-2">|</div>
          <div className="d-flex align-items-center pr-2">
            <img src="/images/attack-surface/date-icon.svg" alt="" className="mr-2"/>
            {selectedDateFilter?.startDate?.toDateString()} - {selectedDateFilter?.endDate?.toDateString()}

          </div>
          </div>
          
        </div>
        {pageLoading && (
          <Spinner 
            animation="border"
            variant="primary"
            className="ml-2"
            style={{
              width: "20px",
              height: "20px",
            }}
          />
        )}
      </div>

      <div className="stats-tiles-container bg-grey radius-8 mb-3">
        {statsConfig.map((stat, index) => (
          <StatsTile
            key={stat.title}
            title={stat.title}
            value={stat.value}
            isLast={index === statsConfig.length - 1}
          />
        ))}
      </div>

      <div className="accounts-by-geography-container d-flex bg-grey radius-8 mb-3">
        <div className="left-container d-flex flex-column justify-content-between">
          <div className="p-3">
            <div className="f-500 f-grey mb-2">New Accounts</div>
            <div className="f-18 f-500 f-black mt-1"> {pageData?.newAccounts?.total ?? 0} </div>
          </div>
          <div>
            <MyLineChart redraw={false} data={newAccountsData} options={newAccountsOptions} />
            <div className="line-chart-dates-container pt-0">
              <span>{pageData?.newAccounts?.points[0]?.Label}</span>
              <span>{pageData?.newAccounts?.points[pageData?.newAccounts?.points.length - 1]?.Label}</span>
            </div>
          </div>
        </div>
        <div className="right-container">
        <div className="h-100 d-flex flex-column justify-content-between">
          <div className="p-3">
            <div className="d-flex al;ign-items-center justify-content-between">
              <div className="f-500 f-grey">Sign ups</div>
              <div>
               
              </div>
            </div>
            <div className="f-18 f-500 f-black mt-1"> {pageData?.signups?.total ?? 0} </div>
          </div>
          <div>
            <div className="zoom-independent">
              <Bar redraw={false} data={signUpsData} options={signUpsOptions} height={70} />
            </div>
            <div className="line-chart-dates-container pt-0">
              <span>{pageData?.signups?.points[0]?.Label}</span>
              <span>{pageData?.signups?.points[pageData?.signups?.points.length - 1]?.Label}</span>
            </div>
          </div>
        </div>
        </div>

      </div>
      </>
      )}

      <div className="accounts-by-geography-container d-flex bg-grey radius-8 mb-3">
        <div className="left-container p-3">
          <div className="f-grey f-500 mb-3">{variant === "v2" ? (isDistributor ? "Accounts by Location" : "Geography of accounts") : "Geography of accounts"}</div>
         {pageData?.accountsByGeography?.map((item) => {
            return (
              <div className="w-100">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center f-grey gap-8">
                    <span class={`fi fi-${item.Locale?.toLowerCase()}`} />
                    {item.Label}
                  </div>
                  <div className="f-darkgrey">{item?.Value} </div>
                </div>
                <div className="w-100">
                  <progress value={item?.Value} max={100} />
                </div>
              </div>
            );
          })}
        </div>
        <div className="right-container">
        <MapComponent 
          markers={pageData?.accountsByGeography?.map((item) => ({
            id: item.Label,
            coords: { lng: item.longitude, lat: item.latitude },
          }))}
        />
        </div>

      </div>

      {variant !== "v2" ? (
      <div className="d-flex bg-grey radius-8">
        <div className="flex-1 p-3">
            <div className="f-500 f-grey mb-3">Top 10  active MSP's</div>

            {
                pageData?.activeMSPAccounts?.map((item,i)=>{
                    return(
                        <div className="d-flex align-items-center mb-2">   
                        <div className="f-darkgrey mr-2"
                        style={{
                            width:"19px"
                        }}
                        >{i+1} </div> 
                        <div className="d-flex align-items-center f-darkgrey">
                        <img
              alt=""
              src={item?.icon || "/images/user-logo.svg"}
              className="  mr-2 rounded-full"
              width={16}
              height={16}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = "/images/user-logo.svg";
              }}
            /> {item.Label}
                            
                            </div> 
                        
                          </div>
                    )
                })
            }
        </div>
      </div>
) : (
  <>
   {
          !isDistributor && (
            <div className="mb-3">
              <TrialPerformance isDistributor={isDistributor}/>
            </div>
          )
        }
  </>
)}
    </div>}
    </>
  );
};

export default SubscriptionOverview;
